import script from "./FiltrosNoticias.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltrosNoticias.vue?vue&type=script&setup=true&lang=js"

import "./FiltrosNoticias.vue?vue&type=style&index=0&id=4e437eee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e437eee"]])

export default __exports__